import Vue from 'vue';
import Vuex from 'vuex';
import { getCompany } from '@/apis/company';
import { getContact } from '@/apis/contact';
import { getProduct } from '@/apis/product';
import { getArticle } from '@/apis/article';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentProductName: '',
    currentArticleTitle: '',
    contact: {},
    company: {},
    compareProduct: 'testCompareProductText',
    productCart: [],
    priceTotal: {}
  },
  mutations: {
    updateproductCart(state, payload) {
      state.productCart = payload;
    },
    updateCurrentCompareProduct(state, payload) {
      state.compareProduct = payload;
    },
    updateContact(state, payload) {
      state.contact = payload;
    },
    updateCompany(state, payload) {
      state.company = payload;
    },
    updateCurrentProductName(state, payload) {
      state.currentProductName = payload;
    },
    updateCurrentArticleTitle(state, payload) {
      state.currentArticleTitle = payload;
    },
    updateLocale(_, payload) {
      Vue.$cookies.set('locale', payload);
      window.location.reload();
    },
  },
  actions: {
    async fetchCompany({ commit }) {
      try {
        const company = await getCompany();

        commit('updateCompany', company);
      } catch (e) {
        Vue.sentry.captureException(e);
      }
    },
    async fetchContact({ commit }) {
      try {
        const contact = await getContact();

        commit('updateContact', contact);
      } catch (e) {
        Vue.sentry.captureException(e);
      }
    },
    async fetchCurrentProductName({ commit }, id) {
      try {
        const product = await getProduct(id);

        commit('updateCurrentProductName', product.product_name);
      } catch (e) {
        Vue.sentry.captureException(e);
      }
    },
    async fetchCurrentArticleTitle({ commit }, id) {
      try {
        const article = await getArticle(id);

        commit('updateCurrentArticleTitle', article.title);
      } catch (e) {
        Vue.sentry.captureException(e);
      }
    },
  },
  modules: {
  },
  getters: {
    compareProduct: state => state.compareProduct,
    productCart: state => state.productCart
  }
});
